module.exports = __webpack_public_path__ + "static/media/SaifeeEvents243.61455879.jpg";